import { displayFnWrapper } from '../../utils/dynamic-data-retrievers';

export const emeaPropertyNameDisplayFunctions = {
  366: {
    // 366 - Property Name (Poland & Finland)
    displayFn: displayFnWrapper,
  },
  385: {
    // 385 - Property Name (Italy)
    displayFn: displayFnWrapper,
  },
  471: {
    // 471 - Property Name (Norway)
    displayFn: displayFnWrapper,
  },
  490: {
    // 490 - Property Name (Norway)
    displayFn: displayFnWrapper,
  },
  452: {
    // 452 - Property Name (Sweden)
    displayFn: displayFnWrapper,
  },
};
